window.playmotiv.componentloader = {

  load: component => {

    // component is in format: 'plugin-name-version/component/name'
  
    const pluginName = component.split('/')[0]
    const componentName = component.replace(`${pluginName}/`, '');
  
    return new Promise((resolve, reject) => {

      if (!window.playmotiv.comps[pluginName]) {

        return reject(`Plugin ${ pluginName } not activated`);
      }

      const plugincomponent = window.playmotiv.comps[pluginName][componentName]

      if(!plugincomponent) {

        return reject(`Plugin ${ pluginName } has not component ${componentName }`);
      }

      if(plugincomponent.__ready) {

        return resolve(true)
      }

      let basePath = window.playmotiv.pluginsurl

      /* Local developing */

      const searchParams = location.search.substring(1);

      if(searchParams) {

        const pageParams = JSON.parse('{"' + decodeURI(searchParams).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')      
        

        if(
          (  
            pageParams.localdev &&
            pageParams.comps && 
            pageParams.comps.split('%2F').join('/')
                            .split('_').indexOf(componentName) !== -1
          ) 
          ||
          (
            pageParams.localdev && 
            !pageParams.comps
          ) 
        ) {

          basePath = `http://${pageParams.localdev}:${pageParams.port || '8080'}`
        }
      }

      const compdir = `${ basePath }/${ pluginName }/comps/${ componentName }`

      const nocache = Math.floor(new Date().getTime() / 1000)

      const css=document.createElement('link')
      css.setAttribute('rel', 'stylesheet')
      css.setAttribute('type', 'text/css')
      css.setAttribute('href', compdir + '/main.css?ver=' + nocache)

      document.getElementsByTagName('head')[0].appendChild(css)

      const js = document.createElement('script')
      js.addEventListener('load', () => {

          if (window.playmotiv.comps[pluginName][componentName].__dependences) {

            Promise.all(
              window.playmotiv
              .comps[pluginName][componentName]
              .__dependences
              .map(dependence => {
                window.playmotiv.componentloader.load(dependence)
                if (typeof dependence === 'function') {
                
                    return dependence()
                }
                return window.playmotiv.componentloader.load(dependence)
              })
            )
            .then(() => resolve(true))
            .catch(error => reject(error))

          } else {

            resolve(true)
          }
      })
      js.setAttribute('type','text/javascript')
      js.setAttribute('src', compdir + '/main.js?ver=' + nocache)

      document.getElementsByTagName('body')[0].appendChild(js)
    })
  }
}